import { ExternalArticle } from '@/common/api/params/externalArticle'
import { SearchConditionBase } from '@/common/api/search'
import {
  ListFollowTableHeaderProps,
  makeRectPropsForTableHeadItem,
  useListScrollFollow
} from '@/common/app/list'

import TableHeadItem from '@/components/view/atoms/table/TableHeadItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

import ScrollFollowTable from '@/components/container/utils/list/ScrollFollowTable'

import ExternalArticleListRow from './ExternalArticleListRow'

const COLUMNS = ['記事', '取得元', '状態', '閲覧数(30日)', '公開日時', '最終取得', '操作']

interface TheadProps extends ListFollowTableHeaderProps {
  float?: boolean
}

const Thead = ({ float = false, rowRefs, rowRects }: TheadProps) => {
  const rectProps = (index: number) =>
    makeRectPropsForTableHeadItem(rowRefs, rowRects, index, float)

  return (
    <>
      {COLUMNS.map((col, i) => (
        <TableHeadItem key={col} float={float} {...rectProps(i)}>
          <Text size={12} color={TextColor.SECONDARY}>
            {col}
          </Text>
        </TableHeadItem>
      ))}
    </>
  )
}

interface Props {
  articles: ExternalArticle[]
  total: number
  condition: SearchConditionBase
  onUpdatePage: (page: number) => void
  refetchingId: number | null
  onClickRow(article: ExternalArticle): void
  onRefetch(article: ExternalArticle): void
  onDelete(article: ExternalArticle): void
}

const ExternalArticleListTable = ({
  articles,
  total,
  condition,
  onUpdatePage,
  refetchingId,
  onClickRow,
  onRefetch,
  onDelete
}: Props) => {
  const listFollowProps = useListScrollFollow(COLUMNS.length)
  const { header } = listFollowProps

  const theadProps: TheadProps = { ...header }

  return (
    <ScrollFollowTable
      listFollowProps={listFollowProps}
      tableHead={<Thead {...theadProps} />}
      tableFloatHead={<Thead {...theadProps} float />}
      body={
        <>
          {articles.map((article) => (
            <ExternalArticleListRow
              key={article.id}
              article={article}
              refetching={refetchingId === article.id}
              onClick={() => onClickRow(article)}
              onRefetch={() => onRefetch(article)}
              onDelete={() => onDelete(article)}
            />
          ))}
        </>
      }
      condition={condition}
      onUpdatePage={onUpdatePage}
      total={total}
    />
  )
}

export default ExternalArticleListTable
